interface ErrorResponse {
  status: number;
  data: {
    message: string;
  };
}

export const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'object' && error !== null && 'data' in error) {
    const errorResponse = error as ErrorResponse;
    return errorResponse.data?.message || 'Something went wrong';
  }
  return 'Something went wrong';
};

export const getErrorStatus = (error: unknown): number => {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const errorResponse = error as ErrorResponse;
    return errorResponse.status || 500;
  }
  return 500;
};

export const is403ErrorStatus = (error: unknown): boolean => {
  return getErrorStatus(error) === 403;
}; 